/**
 * What clients and other contexts read of Gamification and rewards, safe for
 * every bundle: the wire shapes of the score, Gem and profile stats
 * procedures, the fan status Link in Bio shows, and the legacy fan-level
 * formula the profile stats score top artists with. The Inngest event that
 * asks for a fan's stats refresh is server-only:
 * `@libs/gamification-rewards-contracts/events`.
 */
export * from "./scoring";
export * from "./wire/artist-community";
export * from "./wire/artist-fan-status";
export * from "./wire/gamification";
export * from "./wire/stats";
